import { Badge } from "@/components/ui/badge";

interface LoanStatusBadgeProps {
  status: string;
}

const getStatusVariant = (status: string): "default" | "destructive" | "secondary" | "outline" => {
  switch (status.toLowerCase()) {
    case 'approved':
      return "secondary";
    case 'pending':
      return "outline";
    case 'rejected':
      return "destructive";
    default:
      return "default";
  }
};

export const LoanStatusBadge = ({ status }: LoanStatusBadgeProps) => {
  return (
    <Badge variant={getStatusVariant(status)}>
      {status}
    </Badge>
  );
};